import { useContext, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import styles from "./styles.module.css";
import { MdClose } from "react-icons/md";
import { UtilitiesValue, UtilitiesDisbatch } from "../../../contexts/utilities";
import AddUtility from "./addutility";
import Card from "./card";
import Editor from "./editor";
import BottomTarget from "./bottomtarget";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";

export default function Utilities() {
  const { utilities, add, editor, open } = useContext(UtilitiesValue);
  const disbatch = useContext(UtilitiesDisbatch);
  const { appId, pageId, type } = useParams();

  const convertToNull = (obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === undefined) {
        obj[key] = null;
      } else if (typeof obj[key] === "object" && !!obj[key]) {
        obj[key] = convertToNull(obj[key]);
      }
    });
    return obj;
  };

  const handleAddUtility = (u) => {
    const _utilities = [...utilities];
    _utilities.push(u);
    disbatch({ type: "set", value: _utilities });
    disbatch({ type: "setAdd", value: false });
    disbatch({ type: "setEditor", value: u });
  };

  const handleSave = (u) => {
    const _utilities = [...utilities];
    const index = _utilities.findIndex((x) => x.id === u.id);
    const _u = convertToNull({ ...u });
    _utilities[index] = _u;

    disbatch({ type: "set", value: _utilities });
    disbatch({ type: "setEditor", value: _u });
  };

  const handleDelete = (u) => {
    const _utilities = [...utilities];
    const index = _utilities.findIndex((x) => x.id === u.id);
    _utilities.splice(index, 1);
    disbatch({ type: "setEditor", value: {} });
    disbatch({ type: "set", value: _utilities });

    db.collection("apps")
      .doc(appId)
      .collection(type)
      .doc(pageId)
      .collection("utilities")
      .doc(u.id)
      .delete();
  };

  const handleDrop = (fromIndex, toIndex) => {
    const _utilities = [...utilities];
    const utility = _utilities[fromIndex];
    if (fromIndex > toIndex) {
      //delete then insert
      _utilities.splice(fromIndex, 1);
      _utilities.splice(toIndex, 0, utility);
    } else {
      //insert then delete
      _utilities.splice(toIndex, 0, utility);
      _utilities.splice(fromIndex, 1);
    }
    disbatch({ type: "set", value: _utilities });
  };

  const handleBlankDrop = (fromIndex) => {
    const _utilities = [...utilities];
    const utility = _utilities[fromIndex];
    _utilities.splice(fromIndex, 1);
    _utilities.splice(_utilities.length, 0, utility);
    disbatch({ type: "set", value: _utilities });
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div
        className={open ? styles.backdrop + " " + styles.open : styles.backdrop}
        onClick={() => disbatch({ type: "setOpen", value: false })}
      >
        <div
          className={
            open ? styles.utilities + " " + styles.open : styles.utilities
          }
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 15,
            }}
          >
            <div className={styles.title}>Utilities</div>
            <MdClose
              className={styles.close}
              onClick={() => disbatch({ type: "setOpen", value: false })}
            />
          </div>
          <div style={{ display: "flex", flexGrow: 1 }}>
            <div
              style={{ display: "flex", flexDirection: "column", width: 340 }}
            >
              <button
                onClick={() => disbatch({ type: "setAdd", value: true })}
                className={styles.add}
              >
                Add Utility
              </button>
              <div style={{ padding: 15 }}>
                {utilities.map((u, i) => {
                  return (
                    <Card
                      onClick={() => disbatch({ type: "setEditor", value: u })}
                      selected={editor.id === u.id}
                      key={u.id}
                      utility={u}
                      index={i}
                      onDrop={handleDrop}
                    />
                  );
                })}
                <BottomTarget handleBlankDrop={handleBlankDrop} />
              </div>
            </div>
            <Editor
              utility={editor}
              onDelete={handleDelete}
              onChange={handleSave}
              open={!!editor.id}
            />
          </div>
        </div>
        <AddUtility
          open={add}
          onSelect={handleAddUtility}
          onClose={() => disbatch({ type: "setAdd", value: false })}
        />
      </div>
    </DndProvider>
  );
}
